import {
  ActivityIndicator, Dimensions, Image, StyleSheet, Text, TouchableOpacity, View
} from "react-native";
import { useCallback, useEffect, useState } from "react";
import Entypo from '@expo/vector-icons/Entypo';
import AntDesign from '@expo/vector-icons/AntDesign';
import { MediaModal } from "./chat/mediaModal";
import { CurrentMsgMedias, PuzzleThemeCharacter, PuzzleThemeMedia } from "../data/types";
import { PuzzleAPI } from "../data/puzzleApi";

let { width } = Dimensions.get('window');
if(width > 460){ width = 460; }
const COLUMN_WIDTH = width / 4 - 10;

export const AlbumList = ({
  themeInfo,
  onClose
}:{
  themeInfo: PuzzleThemeCharacter;
  onClose: ()=> void;
}) => {
  const [medias, setMedias] = useState<PuzzleThemeMedia[]>([]);
  const [openMediaModal, setOpenMediaModal] = useState(false);
  const [currentMessageMedias, setCurrentMessageMedias] = useState<CurrentMsgMedias[]>([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const musicAll = [
    require("../assets/musics/music1.mp3"),
    require("../assets/musics/music2.m4a"),
    require("../assets/musics/music3.m4a"),
    require("../assets/musics/music4.m4a"),
    require("../assets/musics/music5.m4a"),
    require("../assets/musics/music6.m4a"),
    require("../assets/musics/music7.m4a"),
    require("../assets/musics/music8.m4a"),
  ]
  const [checkedMusic, setCheckedMusic] = useState(musicAll[0]);

  const getMediaChange = async ()=>{
    let res = await PuzzleAPI.getPuzzleImages(themeInfo.id);
    if(res && res.list){
      res.list.forEach((item)=>{
        if(
          item.rewarded_video_url &&
          !item.rewarded_video_url.includes("http")
        ){
          item.rewarded_video_url = "https://puzzle.snackbook.cc" + item.rewarded_video_url;
        }
        if(!item.thumbnail_url.includes("http")){
          item.thumbnail_url = "https://puzzle.snackbook.cc" + item.thumbnail_url;
        }
        if(!item.url.includes("http")){
          item.url = "https://puzzle.snackbook.cc" + item.url;
        }
      })
      setMedias(res.list || []);
    }
  };

  useEffect(()=>{
    getMediaChange();
  },[])
  
  const handleImagePress = (
    item: PuzzleThemeMedia,
    index: number
  )=>{
    setOpenMediaModal(true);
    let media_arr = medias
        // .filter((item)=>!item.disabled)
        .map(item=> ({image: item.url, video: item.rewarded_video_url }))
    setCurrentMessageMedias(media_arr);
    let idx = index;
    let music_idx = index % musicAll.length;
    setCheckedMusic(musicAll[music_idx]);
    setSelectedImageIndex( idx );
  };

  const RenderItem = useCallback(({
    item, index
  }: {
    item: PuzzleThemeMedia, index: number
  }) => (
    <View style={styles.card}>
      <TouchableOpacity style={styles.touchable}
        onPress={() => handleImagePress(item, index)}
      >
        <Image source={{ uri: item.thumbnail_url }}
          style={{ width: '100%', height: '100%' }}
          blurRadius={ 0 } resizeMode="cover"
        />
        {item.rewarded_video_url && (
          <View style={styles.videoClasses}>
            <AntDesign name="play" size={20} color="rgb(173, 8, 255)" />
          </View>
        )}
      </TouchableOpacity>
    </View>
  ),[medias]);

  return (
    <View style={{ minHeight: 600 }}>
      <View style={{ padding: 10 }}>
        <TouchableOpacity style={{
          flexDirection: "row", alignItems: "center", gap: 8,
        }} onPress={onClose}>
          <Entypo name="chevron-left" size={24} color="#FFFFFF" />
          <Text style={{
            color: "#FFFFFF", fontSize: 18, fontWeight: "700",
          }}>
            {themeInfo.role_name}
          </Text>
        </TouchableOpacity>
      </View>
      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
        {medias.map((item,index)=>(
          <RenderItem item={item} index={index} key={item.id} />
        ))}
      </View>
      {medias.length === 0 && (
        <View style={{ paddingVertical: 20, justifyContent: 'center' }}>
          <ActivityIndicator size="large" color="rgb(173, 8, 255)" />
        </View>
      )}
            
      <MediaModal
        open={openMediaModal}
        setOpen={setOpenMediaModal}
        musicUrl={checkedMusic}
        list={currentMessageMedias}
        defaultIndex={selectedImageIndex}
      />
    </View>
  )
};

const styles = StyleSheet.create({
  card: {
    width: COLUMN_WIDTH,
    margin: 5,
    borderRadius: 10,
    backgroundColor: "transparent",
    overflow: 'hidden',
    aspectRatio: 1, // Widescreen aspect ratio (16:9)
  },
  touchable: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  videoClasses:{
    position: "absolute",
    top: 10,
    right: 10,
  },
})